import { useEffect, useState, useCallback } from "react";
import { Heart, Library, Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";

export default function ShelfPicker({ bookId }) {
  const [shelves, setShelves] = useState([]);
  const [name, setName] = useState("");

  const load = useCallback(() => {
    api.get("/shelves", { params: { book_id: bookId } }).then((r) => setShelves(r.data.shelves)).catch(() => {});
  }, [bookId]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (s) => {
    try {
      if (s.has_book) await api.delete(`/shelves/${s.id}/books/${bookId}`);
      else await api.post(`/shelves/${s.id}/books`, { book_id: bookId });
      setShelves((v) => v.map((x) => (x.id === s.id ? { ...x, has_book: !x.has_book } : x)));
      toast.success(s.has_book ? `removed from ${s.name.toLowerCase()}` : `added to ${s.name.toLowerCase()}`);
    } catch { toast.error("could not update shelf"); }
  };

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const r = await api.post("/shelves", { name: name.trim() });
    await api.post(`/shelves/${r.data.id}/books`, { book_id: bookId });
    setName("");
    load();
    toast.success(`added to ${r.data.name.toLowerCase()}`);
  };

  const fav = shelves.find((s) => s.system === "Favorites");

  return (
    <div className="flex gap-2">
      {fav && (
        <button onClick={() => toggle(fav)} data-testid="favorite-toggle-btn"
          className={`inline-flex items-center gap-2 font-ui text-xs tracking-caps px-4 py-2 rounded-full border transition-colors ${fav.has_book ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-secondary"}`}>
          <Heart className={`w-3.5 h-3.5 ${fav.has_book ? "fill-current" : ""}`} /> {fav.has_book ? "favorited" : "favorite"}
        </button>
      )}
      <Popover>
        <PopoverTrigger asChild>
          <button data-testid="add-to-shelf-btn" className="inline-flex items-center gap-2 font-ui text-xs tracking-caps px-4 py-2 rounded-full border border-border hover:bg-secondary transition-colors">
            <Library className="w-3.5 h-3.5" /> add to shelf
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 font-ui p-2" align="start">
          {shelves.filter((s) => s.system !== "Favorites").map((s) => (
            <button key={s.id} onClick={() => toggle(s)} data-testid={`shelf-option-${s.id}`}
              className="w-full flex items-center justify-between px-3 py-2 rounded hover:bg-secondary text-sm">
              {s.name} {s.has_book && <Check className="w-4 h-4 text-primary" />}
            </button>
          ))}
          <form onSubmit={create} className="flex gap-1 mt-2 pt-2 border-t border-border">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="new shelf…" className="h-8 text-sm" data-testid="new-shelf-input" />
            <button type="submit" data-testid="create-shelf-btn" className="px-2 rounded bg-primary text-primary-foreground"><Plus className="w-4 h-4" /></button>
          </form>
        </PopoverContent>
      </Popover>
    </div>
  );
}
